import {
    configReducer,
    formReducer,
    gridReducer,
    menuLateralReducer,
    companySelector
} from 'skrit-web-framework/reducers';

/* Temporary function */
function reduceReducers(...reducers) {
    return (previous, current) =>
        reducers.reduce((p, r) => r(p, current), previous);
}

/* Custom root reducer */
const skritApp = reduceReducers(
    formReducer,
    configReducer,
    gridReducer,
    menuLateralReducer,
    companySelector
);

export default skritApp;
